import { Maybe } from '@ats/api/cm';

export class AtsUtility {
	public static isTruthyOrZero(value: any) {
		return value || value === 0;
	}

	public static isNotNullOrUndefined = <T = any>(
		input: null | undefined | Maybe<T> | T
	): input is T => input !== null && input !== undefined;
}
